export default __webpack_public_path__ + "static/media/figure_service.f1765f2b.png";